import script from "./CustomHotKeyInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomHotKeyInput.vue?vue&type=script&setup=true&lang=ts"

import "./CustomHotKeyInput.vue?vue&type=style&index=0&id=16130bbb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16130bbb"]])

export default __exports__